import { render, staticRenderFns } from "./TwoSegmentsMixOptions.vue?vue&type=template&id=be5ede3c&lang=pug&"
import script from "./TwoSegmentsMixOptions.vue?vue&type=script&lang=js&"
export * from "./TwoSegmentsMixOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports